












































import MExpansion from "@/components/utility/mmmint/MExpansion.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import PartnerReportClearanceCard from "./PartnerReportClearanceCard.vue";
import ReportClearanceDialog from "./ReportClearanceDialog.vue";

@Component({
  components: {
    MIconButton,
    MNoContent,
    ReportClearanceDialog,
    PartnerReportClearanceCard,
    MExpansion
  }
})
export default class PartnerReportClearancesCard extends mixins(PermissionMixin) {
  isClearanceDialogOpen = false;
  showClearances = false;

  get report() {
    return PartnerModule.report;
  }

  goToClearanceApprovalDetail(clearanceApproval: IClearanceApproval) {
    clearanceApproval.goTo(this.$router).detail();
  }
}
